// extracted by mini-css-extract-plugin
module.exports = {"content":"Breadcrumb__content___23ID0","item":"Breadcrumb__item___21OEN"};